import React, { useEffect } from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import Slider from "react-slick";
import  rings from '../assets/images/shop-by-category/rings.webp'
import  earings from '../assets/images/shop-by-category/earings.jpg'
import  necklaces from '../assets/images/shop-by-category/necklaces.jpg'
import  pendants from '../assets/images/shop-by-category/pendants.jpg'
import  weddingRings from '../assets/images/shop-by-category/wedding-rings.jpg'
import  arrowleft from '../assets/images/arrow-left-green.png'
import  arrowright from '../assets/images/arrow-right-green.png'

// Helper function for image paths
const getImagePath = (filename) => `${ImageUrl}theme/showcase/${filename}`;

const collections = [
  { name: "Engagement Rings", path: "/engagement", image:rings },
  { name: "Wedding Rings", path: "/jewelry/wedding-rings", image: weddingRings },
  { name: "Pendants", path: "/jewelry/pendants", image: pendants },
  { name: "Necklaces", path: "/jewelry/necklaces", image: necklaces },
  { name: "Earrings ", path: "/jewelry/earrings", image: earings },
];

const ExploreCollection = () => {
useEffect(() => {
    const updateTabIndex = () => {
      document.querySelectorAll(".slick-slide[aria-hidden='true']").forEach((slide) => {
        slide.querySelectorAll("a, button, input, textarea, select").forEach((el) => {
          el.setAttribute("tabindex", "-1");
        });
      });
  
      document.querySelectorAll(".slick-slide[aria-hidden='false']").forEach((slide) => {
        slide.querySelectorAll("a, button, input, textarea, select").forEach((el) => {
          el.setAttribute("tabindex", "0");
        });
      });
    };
  
    // Run on mount
    updateTabIndex();
  
    // Re-run after a short delay in case of dynamic content
    setTimeout(updateTabIndex, 500);
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 5,
    prevArrow: <Image src={arrowleft} alt="left arrow" />,
    nextArrow: <Image src={arrowright} alt=" Rigth arrow" />,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
          
        }
      }
    ],
    beforeChange: () => {
      setTimeout(() => {
        const slides = document.querySelectorAll(".slick-slide");
        slides.forEach((slide) => {
          const isHidden = slide.getAttribute("aria-hidden") === "true";
          slide.querySelectorAll("a, button, input, textarea, select").forEach((el) => {
            el.setAttribute("tabindex", isHidden ? "-1" : "0");
          });
        });
      }, 100); // You can increase this to 300–500ms if needed
    }
  };
  return (
    <section className="explore-collection">
      <Container fluid className="showcase-container">
        <Heading className="text-md-left text-lg-left text-sm-center text-center">
          <h2>Shop Jewelry by Category</h2>
          <p> To easily find pieces that match your style and occasion.
          </p>
        </Heading>
        <Row>
        <Col sm={12} md={12} lg={12}>
          <Slider {...settings}>            
            {collections.map(({ name, path, image }) => (
                      <div className="item text-center img_box_outer">
                      <Link to={path} className="img-box" aria-label={`Shop ${name}`}>
                        <Image src={image} alt={name} loading="lazy" />
                      </Link>
                      <Link to={path}>{name}</Link>
                    </div>                       
          ))}
          </Slider>
        </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ExploreCollection;
